<template>
  <div :class="cssType" class="post">
    <div class="blue-line-1"></div>
    <div class="blue-line-2"></div>
    <div class="blue-line-3"></div>
    <div class="post-content">
      <div class="title">
        {{ $t('payment.post.title') }}
      </div>
      <div class="tabs">
        <button class="tab-btn" :class="{ active: state.activeTab === 'announcement' }" @click="changeTab('announcement')">{{ $t('payment.post.announcement') }}</button>
        <button class="tab-btn" :class="{ active: state.activeTab === 'faq' }" @click="changeTab('faq')">{{ $t('payment.post.faq') }}</button>
      </div>
      <div class="article">
        <div class="article-content">
          <div class="richtext" v-if="state.activeTab === 'announcement'" v-html="state.announcementContent"></div>
          <div class="richtext" v-if="state.activeTab === 'faq'" v-html="state.faqContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue'
import { isMobile } from '@/utils'
import Api from '@/config/api'
const cssType = isMobile ? 'mobile' : 'pc'
const state = reactive({
  activeTab: 'announcement', // announcement, faq
  list: [],
  announcementContent: computed(() => {
    const item = state.list.find(item => item.articleType === 1)
    return item ? item.articleContent : ''
  }),
  faqContent: computed(() => {
    const item = state.list.find(item => item.articleType === 2)
    return item ? item.articleContent : ''
  }),
})

const changeTab = (tab) => {
  state.activeTab = tab
}

const getPostList = async () => {
  const res = await Api.getPostList()
  console.log(res)
  state.list = res?.articles || []
}
getPostList()
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
